import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowsMergeRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 8.188c0-.658.543-1.187 1.219-1.187H9.31a4.93 4.93 0 0 1 3.88 1.87l4.306 5.507a2.46 2.46 0 0 0 1.94.935h5.402l-1.98-1.93a1.16 1.16 0 0 1 0-1.677 1.24 1.24 0 0 1 1.72 0l4.063 3.959a1.16 1.16 0 0 1 0 1.677l-4.062 3.959a1.236 1.236 0 0 1-1.721 0 1.166 1.166 0 0 1 0-1.678l1.98-1.93h-5.403c-.761 0-1.477.347-1.94.936l-4.305 5.502A4.93 4.93 0 0 1 9.31 26H4.22c-.676 0-1.219-.53-1.219-1.187 0-.659.543-1.188 1.219-1.188h5.09c.762 0 1.478-.346 1.94-.935l4.306-5.507q.297-.379.655-.683a5 5 0 0 1-.655-.683L11.25 10.31a2.46 2.46 0 0 0-1.94-.935H4.22C3.543 9.376 3 8.846 3 8.188",
		fill: "currentColor"
	})
});
export default SvgArrowsMergeRegularIcon;
